import React from "react"
import { graphql } from "gatsby"
import parse from 'html-react-parser'

import Layout from "../components/layout.js"
import SEOhead from "../components/seo.js"
import HeadCSS from "../components/headCss.js"

import { PrepMedia } from '../utils/globalUtils.js'

const PageTemplate = ({ data }) => {
	let pageData = data.wpPage
	let elementorCssKit = JSON.parse(data.wp.elementorCssKit)

	let content = ( pageData.content ) 
		? pageData.content : ''
	let elementorHF = JSON.parse(data.wp.elementorHF)

    content = content.replace(
            /<iframe/g, 
            '<iframe data-page-slug="'+ pageData.seo.opengraphUrl +'"'
        )
	
	return(
		<Layout id={pageData.databaseId}
				activeKitId={elementorCssKit.activeKitId}
				headerContent={elementorHF.header.content}
				footerContent={elementorHF.footer.content}
			>

			{ 	
				content &&
				parse(content, { replace: PrepMedia })
			}
			
		</Layout>
	)
}

export default PageTemplate

export const Head = ({ data }) => {
	let { seo, customJsonLD } = data.wpPage

	return(
		<>
			<SEOhead data={seo} customJsonLD={customJsonLD}/>
			<HeadCSS data={data} />
		</>
	)
}

export const query = graphql`
	query($id: String) {
		wpPage(id: { eq: $id }) {
			content
			databaseId
			elementorCss
			elementorData
			template {
				templateName
			}
			title
			customJsonLD
			seo {
				metaDesc
				metaRobotsNofollow
				metaRobotsNoindex
				opengraphUrl
				opengraphType
				opengraphAuthor
				opengraphDescription
				opengraphImage {
					localFile {
						publicURL
					}
				}
				opengraphTitle
				title
				twitterDescription
				twitterTitle
				schema {
					raw
				}
			}
		}
		wp {
            elementorCssKit
			elementorHF
        }
	}
`